import React, { useState } from "react";

/**
 * Collapsible block that shows model reasoning / chain-of-thought content.
 * Streams in real-time while isStreaming=true, then collapses once the
 * main response has arrived.
 */
export default function ThinkingBlock({ content, isStreaming = false }) {
  const [expanded, setExpanded] = useState(isStreaming);

  if (!content) return null;

  return (
    <div className="mb-2">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-1 text-[11px] text-purple-600 hover:text-purple-800 transition-colors"
      >
        <svg
          className={`w-3 h-3 transition-transform ${expanded ? "rotate-90" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
        <span className="font-medium">
          {isStreaming ? "Thinking..." : "View thinking"}
        </span>
        {isStreaming && (
          <span className="inline-block h-3 w-0.5 animate-pulse bg-purple-500 rounded" />
        )}
      </button>

      {expanded && (
        <div className="mt-1 ml-1 pl-3 border-l-2 border-purple-200">
          <p className="text-[11px] text-gray-500 italic whitespace-pre-wrap leading-relaxed">
            {content}
          </p>
        </div>
      )}
    </div>
  );
}
